import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { elementGroups } from '../data/periodicTableData';
const GroupNavigation: React.FC = () => {
  const {
    groupId
  } = useParams<{
    groupId: string;
  }>();
  return <div className="mb-6 overflow-x-auto" data-id="element-36">
      <div className="flex space-x-2 min-w-max pb-2" data-id="element-37">
        <Link to="/" className="px-4 py-2 rounded-md bg-blue-100 hover:bg-blue-200 text-blue-800 font-medium" data-id="element-38">
          Overview
        </Link>
        {Object.entries(elementGroups).map(([id, group]) => <Link key={id} to={`/group/${id}`} className={`px-4 py-2 rounded-md transition-colors ${groupId === id ? 'bg-blue-600 text-white' : 'bg-gray-100 hover:bg-gray-200 text-gray-800'}`} data-id="element-39">
            {group.name}
          </Link>)}
      </div>
    </div>;
};
export default GroupNavigation;